(ns app.front.view.admin.commands.remove-duplicate-entities
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::remove
  (fn [_ [_ entity-1-id entity-2-id]]
    {:comm/command {:command :admin/remove-duplicate-entities
                    :method  :post
                    :data    {:entity-1-id (parse-long entity-1-id)
                              :entity-2-id (parse-long entity-2-id)}
                    :notify  {:success "Duplicate entity removed"}}}))

(defn view [match]
  [acommon/admin-page-v2 (util/mmap {:title "Remove duplicate entities"} match)
   [:section
    [:div
     [ui/help "In case a duplicate entity was created accidentally, for example because a user had a slow computer but fast mouse clicking skills and those clicks resulted in two separate calls for two different production backends resulting in the creation of two of the intended entities this tool can be used to remove one of them, since duplicates are not generally expected in other places.
                The requirements for removable entities are as follow:
                - Must have different entity ids
                - Must have identical entity types
                - Must have the same creator if any
                - Must have been created within +/- 10 seconds of each other"]]]
   (r/with-let [*entity-1-id (r/atom nil)
                *entity-2-id (r/atom nil)]
     [:section
      [:div.p-6
       [ui/number-input {:id          "entity-1-id"
                         :light       true
                         :value       @*entity-1-id
                         :required    true
                         :on-change   #(reset! *entity-1-id (futil/tval %))
                         :placeholder "Entity ID"
                         :label-text  "ID for the first entity. This entity will remain."}]]
      [:div.p-6
       [ui/number-input {:id          "entity-2-id"
                         :light       true
                         :value       @*entity-2-id
                         :required    true
                         :on-change   #(reset! *entity-2-id (futil/tval %))
                         :placeholder "Entity ID"
                         :label-text  "ID for the second entity. This entity will be removed."}]]
      [:div.p-6
       (cc/button {:kind     :primary
                   :disabled (or (nil? @*entity-1-id)
                                 (nil? @*entity-2-id)
                                 (= @*entity-1-id @*entity-2-id))
                   :on-click #(>evt [::remove @*entity-1-id @*entity-2-id])}
                  "Remove duplicate entity")]])])

(def route
  {:name        :view/admin.commands.remove-duplicate-entities
   :own-layout? true
   :view        view})
